module.exports = __webpack_public_path__ + "static/media/xls.10f98512.png";